import React, { memo } from "react";
import useSendNotificationDialog from "./index.hooks";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Tooltip,
  Typography,
} from "@material-ui/core";
import { AppButton, AppFilterableSelect, AppTextField } from "components/index";
import NotificationsIcon from "@material-ui/icons/Notifications";
import Avatar from "@material-ui/core/Avatar";
import CloseIcon from "@material-ui/icons/Close";

type SendNotificationDialogProps = {};

const SendNotificationDialog = ({}: SendNotificationDialogProps) => {
  const {
    styles,
    classes,
    atomicStyles,
    open,
    handleDialogClose,
    isMobile,
    options,
    watch,
    onSubmit,
    register,
    handleSelection,
    isValid,
    placeholder,
    errors,
    isLoading,
    t,
    eventTitle,
    onEventTextChange,
  } = useSendNotificationDialog();

  return (
    <Dialog
      open={open}
      onClose={handleDialogClose}
      fullWidth
      maxWidth={isMobile ? "xs" : "sm"}
      classes={classes.dialogPaper}
    >
      <Avatar className={styles.dialogAvatar}>
        <NotificationsIcon className={styles.dialogIcon} />
      </Avatar>
      <IconButton className={styles.closeButton} onClick={handleDialogClose}>
        <CloseIcon />
      </IconButton>
      <DialogTitle>
        <Typography
          variant={"h6"}
          color={"primary"}
          style={{ textAlign: "center" }}
        >
          {t("Nuova notifica")}
        </Typography>
      </DialogTitle>
      <DialogContent className={styles.dialogContent}>
        <form onSubmit={onSubmit}>
          <AppFilterableSelect
            options={options}
            disabled={isLoading}
            placeholder={placeholder}
            fullWidth={isMobile}
            inputClassName={styles.inputProps}
            dropdownClassName={styles.dropDown}
            onItemSelected={handleSelection}
            className={styles.searchBar}
            error={errors?.eventId}
            searchValue={eventTitle}
            onChange={onEventTextChange}
          />
          <div className={styles.inputsRoot}>
            <div className={styles.inputContainer}>
              <AppTextField
                variant={"outlined"}
                fullWidth
                disabled={isLoading}
                name={"title"}
                noHelper={isMobile}
                tooltippedError={isMobile}
                label={t("Titolo")}
                inputRef={register}
                error={!!errors.title}
                helperText={errors?.title?.message}
                maxChars={30}
                currentCount={watch("title", "").length}
                style={{ marginBottom: "1em" }}
              />
              <AppTextField
                variant={"outlined"}
                fullWidth
                multiline
                disabled={isLoading}
                tooltippedError={isMobile}
                noHelper={isMobile}
                rows={isMobile ? 2 : 3}
                rowsMax={isMobile && 2}
                name={"description"}
                label={t("Messaggio notifica")}
                inputRef={register}
                error={!!errors.description}
                helperText={errors?.description?.message}
                maxChars={100}
                currentCount={watch("description", "").length}
                style={isMobile ? { marginTop: "1em" } : {}}
              />
            </div>
            <div className={styles.buttonsContainer}>
              <AppButton
                variant={"contained"}
                color={"secondary"}
                onClick={onSubmit(true)}
                disabled={!isValid || isLoading}
                style={{ margin: 0, width: 115 }}
              >
                Test
              </AppButton>
              <AppButton
                variant={"contained"}
                color={"primary"}
                onClick={onSubmit(false)}
                disabled={!isValid || isLoading}
                style={{ margin: 0, width: 115 }}
              >
                {t("Produzione")}
              </AppButton>
            </div>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default memo(SendNotificationDialog);
